import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#2E3438",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M22.499 4.756a2.2 2.2 0 1 0-3.112-3.112L8.37 12.66l3.111 3.11zM18.287 2.745l3.111 3.111M4.074 18.6h-.73a2.2 2.2 0 1 0 0 4.4h15.401M8.37 12.66l-1.363 4.474 4.474-1.363z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#2E3438",
      d: "m10.31 11.194 8.615-8.36L21.31 5.18l-8.318 8.654z"
    }, null, -1)
  ])))
}
export default { render: render }